// Shared so the settings form refuses exactly what the mutator refuses. When
// the form was looser, a rejected URL threw in the optimistic mutator and the
// connector vanished with nothing on screen.
export function providerUrlError(url: string): string | null {
	let parsed: URL
	try {
		parsed = new URL(url)
	} catch {
		return "Enter a valid URL, like https://api.example.com/productlane"
	}
	if (parsed.protocol === "https:") return null
	if (parsed.protocol === "http:" && parsed.hostname === "localhost")
		return null
	if (parsed.protocol === "http:") {
		return `http:// works only for localhost, so "${parsed.hostname}" needs https://`
	}
	return "The URL must start with https://"
}

// Rendered as an <img> for every teammate, so only https.
export function connectorLogoUrlError(url: string): string | null {
	try {
		return new URL(url).protocol === "https:"
			? null
			: "The logo URL must start with https://"
	} catch {
		return "Enter a valid logo URL, like https://example.com/logo.png"
	}
}

export function assertValidProviderUrl(url: string): void {
	const error = providerUrlError(url)
	if (error) throw new Error(error)
}
